import React from 'react';
import { ListItem, ListItemText } from 'material-ui/List';

const DeliveryOutOfPlanItem = ({ data }) => {
    const payload = data.payload || {};
    const customer = payload.customer || {};
    const address_data = customer.address || {};
    const address = `${address_data.address}, ${address_data.district}, ${address_data.city} - ${address_data.state}`;

    return (
        <ListItem>
            <i className="material-icons" style={{color: '#0598EC'}}>local_shipping</i>
            <ListItemText primary={`Finalizou entrega para ${customer.name}`} secondary={address} />
        </ListItem>
    );

}

export default DeliveryOutOfPlanItem;



// WEBPACK FOOTER //
// ./src/components/Timeline/Delivery/OutOfPlan.js